

import React, { useEffect, useLayoutEffect, useState } from 'react';
import "./Home.scss"
import { Box, Stack } from "@mui/material";
import ContenetPane from "../ContentPane/ContentPane";
import SideMenu from "../menuItems/SideMenu";
import Header from "../header/Header";
import Footer from "../footer/Footer";


const Home = () => {
  const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    handleScroll();
  }, [window.scroll])

  // Function to handle scroll event
  const handleScroll = () => {
    if (window.scrollY > 100) { 
        setIsSticky(true);
    } else {
        setIsSticky(false);
    }
};

useLayoutEffect(() => {
    window.scrollTo(0, 0)
});



  return (
    <>
      <Stack direction={{ xs: "row" }} justifyContent={{ sm: "space-between" }} className={isSticky ? "stricky-fixed" : ""}> 
        {/* <Hidden xsDown> <SideMenu /></Hidden> */}
        <SideMenu />
        <Box flex={4} className="content">
        <Header />
         <div className="body-position-section">
         <ContenetPane />
         </div>
          <Footer />
        </Box>
      </Stack>
    </>
  )
}
export default Home;
